import { defineMessages } from "react-intl";
export var messages = defineMessages({
  loading: {
    id: "jutro-components.widgets.CubeLoader.loading",
    defaultMessage: "Loading"
  }
});